import { PLANET_HOPPERS_MODE } from "../../shared/planetHoppers";
import {
    PICTURE_DETECTIVES_MODE,
    RELIC_RUN_MODE,
    VAULT_BREAKERS_MODE,
    type RoomView
} from "../../shared/game";
import { createVaultCapyBanditMaskElement } from "./vaultCapyShield";

export type LobbyCapyCostume = "astronaut" | "none" | "vault-robber" | "picture-detective" | "relic-adventurer";

export const getLobbyCapyCostume = (mode: RoomView["mode"]): LobbyCapyCostume => {
    if (mode === PLANET_HOPPERS_MODE) return "astronaut";
    if (mode === VAULT_BREAKERS_MODE) {
        return "vault-robber";
    }
    if (mode === PICTURE_DETECTIVES_MODE) {
        return "picture-detective";
    }
    if (mode === RELIC_RUN_MODE) {
        return "relic-adventurer";
    }

    return "none";
};

export const appendLobbyCapyCostumes = (shield: HTMLElement): void => {
    const monocle = document.createElement("span");
    const adventurerHat = document.createElement("span");
    const hatCrown = document.createElement("span");
    const hatBand = document.createElement("span");
    const hatBrim = document.createElement("span");

    monocle.className = "lobby-capy-monocle";
    monocle.setAttribute("aria-hidden", "true");
    adventurerHat.className = "lobby-capy-adventurer-hat";
    adventurerHat.setAttribute("aria-hidden", "true");
    hatCrown.className = "lobby-capy-adventurer-hat-crown";
    hatBand.className = "lobby-capy-adventurer-hat-band";
    hatBrim.className = "lobby-capy-adventurer-hat-brim";
    adventurerHat.append(hatCrown, hatBand, hatBrim);

    const helmet = document.createElement("span"); helmet.className = "ph-capy-helmet"; helmet.setAttribute("aria-hidden", "true"); shield.append(helmet);
    shield.append(createVaultCapyBanditMaskElement(), monocle, adventurerHat);
};
